/**
 * What the studio's routes refuse, in the same words the studio shows before
 * it asks: the API throws them and the studio says them in its tip line.
 */
export const STUDIO_REFUSED = {
  notLive: "That room is not a live room.",
  unpublished: "Publish the page first. Nobody could join.",
  ended: "This live has ended.",
  notStarted: "This live has not started yet.",
  notOpen: "The room opens ten minutes before the live.",
  notNext: "The studio opens for the next session.",
  skipped: "This session is skipped. Bring it back first.",
  missed: "This session's time has passed.",
  noSession: "We couldn't find that session.",
  recordingStarting: "The recording is still starting. Try again in a moment.",
  recordingUnchanged: "The recording did not change. Try again.",
} as const;

/** What a live's moments refuse: the studio's controls, and a guest's answer once it has closed. */
export const MOMENT_REFUSED = {
  notOn: "Moments run while you're live.",
  alreadyUp: "It's already up. Close it when you're done.",
  notUp: "It isn't up yet.",
  skipped: "That moment was skipped.",
  closed: "That moment is closed.",
  gone: "That moment isn't on the board any more.",
  answerClosed: "That moment has closed.",
  answerEarly: "That moment isn't up yet.",
} as const;

/**
 * The preset a host joins on. The kit never marks a remote person as host (every other
 * participant it builds from the room's socket has isHost false), so a page tells who is
 * hosting by this name, which the kit does carry on each participant.
 */
export const HOST_PRESET = "flashroom_host";
